/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, nthChildIterator } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : REPORTS : REPORT CARD : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	reportcard: {
		// animate in
		opacity: '0',
		animationName: 'fadeInUp',
        animationDuration: '.2s',
        animationFillMode: 'forwards',
		extend: nthChildIterator(100, .3, .1),

		borderRadius: pxToEm(5),
		border: `1px solid rgb(236, 240, 247)`,
		width: '100%',
		marginBottom: pxToEm(20),
		transition: 'filter .2s linear 0s',

		'&:hover': {
			filter: 'brightness(85%)'
		},

		'& .report': {

			// ----- HEADER ----- // 
			'&-header': {
				display: 'flex',
				flexWrap: 'wrap',
				justifyContent: 'space-between',
				alignItems: 'center',
				padding: replacePXinStringWithEM('12px 25px'),
				borderBottom: `1px solid rgb(236, 240, 247)`,
				'& .report': {
					'&-title': {
						'& h3': {
							fontSize: pxToEm(22),
							fontWeight: 'normal'
						}
					},
					'&-controls': {
						display: 'flex',
						'& .link': {
							background: 'rgb(242, 244, 248)',
							borderRadius: '100%',
							color: 'rgb(6, 43, 117)',
							display: 'inline-flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: pxToEm(36),
							minWidth: pxToEm(36),
							marginRight: pxToEm(10),
							'&.name-run': {
								background: 'rgb(20, 148, 244)',
								borderRadius: pxToEm(22.5),
								color: '#fff',
								height: pxToEm(36),
								minWidth: pxToEm(76),
								padding: replacePXinStringWithEM('0px 5px'),
								'& .icon': {
									marginRight: pxToEm(8)
								},
								'& .text': {
									fontSize: pxToEm(14)
								},
								'& .loader': {
									fontSize: '30%',
									'& div': {
										borderTopColor: '#fff'
									}
								}
							},
							'&:last-child': { marginRight: '0' }
						}
					}
				}
			},

			// ----- CONTENT ----- // 
			'&-content': {
				display: 'flex',
				flexWrap: 'wrap',
				justifyContent: 'flex-start',
				alignItems: 'flex-start',
				minHeight: pxToEm(85),
				padding: replacePXinStringWithEM('17px 25px 0'),
				// see carddetail for more styles
			}
		}
	}
});